// see corresponding file for CSS here /render-service/src/assets/css/_breakpoints.scss
export enum Breakpoints {
  base = 0,
  s_smartphone_portrait = 320,
  s_smartphone_landscape = 480,
  m_smartphone_landscape = 640,
  s_tablet_portrait = 768,
  s_tablet_landscape = 1024,
  s_screen = 1152,
  m_screen = 1280,
  l_screen = 1440,
  xl_screen = 1600,
  xxl_screen = 1920,
}
